export default  {
	id: '',
	name: '',
	marketing_name: '',
	property:'',
	short_desc: '',
	long_desc: '',
	size: '',
	classification: '',
	color: '',
	sqft_min: '',
	sqft_max: '',
	repetition: '',
	repetition_rules: ''
}